import { DestroyRef, inject, Injectable } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { AcceptInvitationsDialog } from '../../../components/accept-invitations-dialog/accept-invitations.dialog';
import { DialogService, DynamicDialogRef } from 'primeng/dynamicdialog';
import { ProfileService, TeamInvitationsCrudService } from '@tokenbox/services';

@Injectable({
  providedIn: 'root',
})
export class AcceptTeamInvitationsService {
  private destroyRef = inject(DestroyRef);
  private profileService = inject(ProfileService);
  private teamInvitationsCrudService = inject(TeamInvitationsCrudService);
  private dialogService = inject(DialogService);

  private openDialog?: DynamicDialogRef;

  async showPendingInvitationsDialog() {
    await this.profileService.awaitFullProfileSetup();
    this.teamInvitationsCrudService.pendingInvitationsForCurrentUser$
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((invitations) => {
        if (invitations.length > 0) {
          if (!this.openDialog) {
            this.openDialog =
              this.dialogService.open(
                ...AcceptInvitationsDialog(invitations),
              ) ?? undefined;
            this.openDialog?.onClose.subscribe(
              () => (this.openDialog = undefined),
            );
          }
        } else {
          this.openDialog?.close();
          this.openDialog = undefined;
        }
      });
  }
}
